import React from 'react';

import {Rating} from './Rating.jsx';

var ContentRight = React.createClass({
  getInitialState: function (){
    return {show: {'display':'none'}, viewDepend: false}
  },
  addToCart: function(dependencies,slug){
    this.props.addToCart(dependencies,slug);
  },
  buyLib: function(dependencies,slug){
    this.props.buyLib(dependencies,slug);
  },
	componentDidMount: function(){
    /* Toggle expand box => By default keep expand-box as hidden */
    $('.expand-collapse').find(".expand-box").css({'display':'none'});
  },
  handleToggleClick: function (e){
    /* To show and hide expand-box on click */
    this.setState({'display': ''});
    $(e.target).closest('.expand-collapse').find(".expand-box").slideToggle();
    $(e.target).toggleClass("toggle" );
  },
  dependenciesClick: function(e){
    /* To show and hide expand-box on click */
    this.setState({'display': '', viewDepend: !this.state.viewDepend});
    var eTarget = e.target;
    if(!this.state.viewDepend){
      this.props.viewDependencies();
      setTimeout(function(){ 
        $(eTarget).closest('.expand-collapse').find(".expand-box").slideToggle();
        $(eTarget).toggleClass("toggle" );
       }, 1000);
    }
    else{
      $(eTarget).closest('.expand-collapse').find(".expand-box").slideToggle();
      $(eTarget).toggleClass("toggle" );
    }
  },
  render: function(){
  	  var data = this.props.data;
      var lastModified, dateCreated;
        /*for dependencies*/
      const hasKey = (obj, key) => key in obj;
        var dependencies ;
      if (this.props.dependency) {
        if (hasKey(this.props.dependency.data , "items")) {
            var items  = this.props.dependency.data.items || [];
                dependencies =  items.map((value,index) => 
                  <li key = {index} className="product__list--item">
                      <a href="javascript:void(0)">{value["name"]}</a>
                  </li>
            );
         }
      }

      if(Object.getOwnPropertyNames(data).length != 0){
        if (data.hasOwnProperty("modified_date")) {
          let date = new Date(data["modified_date"])
          lastModified = (date.getMonth()+1) + "/" + date.getDate() + "/" + date.getFullYear();
        }
        if (data.hasOwnProperty("created_date")) {
           let date = new Date(data["created_date"])
           dateCreated = (date.getMonth()+1) + "/" + date.getDate() + "/" + date.getFullYear();
        }
       }

        if(data.hasOwnProperty("name")){
           var name = data["name"];
           name = name.split("/");
         }
    return(
          <div className="theme-widgets theme__details right-container">
          { data.hasOwnProperty("licenceType") ?
            <div className="theme-widgets license__typoe">
              <h3>License Type: </h3>
              <p>Universal License <a href="javascript:void(0)" className="tool__tip">
                <i className="fa  fa-question-circle"></i> 
                <strong className="tool__tip--text tool__tip--help">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do aliqua.</strong></a>
              </p>
            </div> : <div /> }
            <div className="theme-widgets payment__details">
            {/*
              <div className="expand-collapse">
                <p><a className="toggle-box" onClick = {this.dependenciesClick} href="javascript:void(0)">View Dependencies</a></p>
                <div className="expand-box"  style = {this.state.show}  >
                  <ul className="product__list list-unstyled">
                    {dependencies}
                  </ul>
                </div>
              </div> 
              */}
              { data.hasOwnProperty("optionalDependencies") ?
              <OptionalDependencies data = {this.props.data}
                                    addToCart = {this.addToCart}
                                    buyLib = {this.buyLib}
                                    handleToggleClick = {this.handleToggleClick} /> : <div /> }
            </div>
            {/*
              <div className="badges">
                 <ul className="badges__list list-inline">
                   <li className="badges__list--item"><img src="images/badge_icon_lg-001.png" alt="badges" title="badges" /></li>
                   <li className="badges__list--item"><img src="images/badge_icon_lg-002.png" alt="badges" title="badges" /></li>
                   <li className="badges__list--item"><img src="images/badge_icon_lg-003.png" alt="badges" title="badges" /></li>
                   <li className="badges__list--item"><img src="images/badge_icon_lg-004.png" alt="badges" title="badges" /></li>
                   <li className="badges__list--item"><img src="images/badge_icon_lg-005.png" alt="badges" title="badges" /></li>
                   <li className="badges__list--item"><img src="images/badge_icon_lg-006.png" alt="badges" title="badges" /></li>
                   <li className="badges__list--item"><img src="images/badge_icon_lg-007.png" alt="badges" title="badges" /></li>
                   <li className="badges__list--item"><img src="images/badge_icon_lg-008.png" alt="badges" title="badges" /></li>
                   <li className="badges__list--item"><img src="images/badge_icon_lg-009.png" alt="badges" title="badges" /></li>
                   <li className="badges__list--item"><img src="images/badge_icon_lg-010.png" alt="badges" title="badges" /></li>
                 </ul>
              </div> */}
            { data.hasOwnProperty("name") ?
              <p>by: {name[0]}</p> : <div /> }
            { data.hasOwnProperty("rating_avg") ?
              <Rating data= {this.props.data}/> : <div /> }
            { data.hasOwnProperty("downloads") ?
              <p>Downloads: {data["downloads"]}</p> : <div /> }
            { data.hasOwnProperty("datePurchased") ?
              <p>Date Purchased: {data["datePurchased"]}</p> : <div /> }
            { data.hasOwnProperty("created_date") ?
              <p>Date Created: {dateCreated}</p> : <div /> }
            { data.hasOwnProperty("modified_date") ?
              <p>Last Modified: {lastModified}</p> : <div /> }
          </div>
    );
  }
});

var OptionalDependencies = React.createClass({
  getInitialState: function(){
    return {dependency: []};
  },
  handleChange: function(e){
    if(e.target.checked == true){
      this.state.dependency.push(e.target.value);
    }
    else if (e.target.checked == false){
      var index = this.state.dependency.indexOf(e.target.value);
      this.state.dependency.splice(index,1);
    }
  },
  handleCartClick: function(){
    this.props.addToCart(this.state.dependency,this.props.data["slug"]);
  },
  handleBuyClick: function(){
    this.props.buyLib(this.state.dependency,this.props.data["slug"]);
  },
  render: function(){
    var optDepend= [];
    // for (var i=0;i<3;i++){
    //   optDepend.push(
    //     <li key = {i}>
    //       <div className="row">
    //         <div className="two_thirds">
    //           <div className="checkbox">
    //             <label htmlFor="StandardBlog">
    //               <input type="checkbox" onChange = {this.handleChange} value={"StandardBlog"+i} name="check" />
    //               Standard Blog {i}
    //             </label>
    //           </div>
    //         </div>
    //         <div className="one_third"> <span className="optional__products--price">$20.00</span> </div>
    //       </div>
    //     </li>
    //     );
    // }
    return(
      <div className="expand-collapse">
        <p><a className="toggle-box" href="javascript:void(0)" onClick = {this.props.handleToggleClick}>Add Optional Dependencies</a></p>
        <div className="expand-box">
          <ul className="optional__products list-unstyled">
          {optDepend}
            <li>
              <div className="row">
                <div className="one_half">
                  <button className="btn__md bg-light_blue" onClick = {this.handleCartClick}><i className="fa fa-shopping-cart"></i> Add to Cart</button>
                </div>
                <div className="one_half">
                  <button className="btn__md bg-bright" onClick = {this.handleBuyClick}>Buy Now</button>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    );
  }
})

export {ContentRight};



/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/ContentRight.jsx
 **/